import React from "react";
import Modal from "./Modal";
import { Button } from "../ui/button";
import { XIcon } from "lucide-react";

interface Props {
  children?: any;
  header: string;
  subHeader?: string;
  onClose?: any;
  headerIcon?: any;
  className?: string;
}

const TempoModal: React.FC<Props> = React.memo((props) => {
  return (
    <Modal>
      <div className={`tempo-modal ${props.className || ""}`}>
        <div className="icon-header">
          {props.onClose && (
            <Button
              variant="outline"
              className="rounded-full text-secondary-n-800 p-1 py-1 px-1 w-6 h-6"
              onClick={props.onClose}
            >
              <XIcon />
            </Button>
          )}
          {props.headerIcon ? (
            <div className="sub-header">{props.headerIcon}</div>
          ) : (
            <div className="modal-header">{props.header}</div>
          )}
        </div>
        {props.headerIcon && <div className="modal-header">{props.header}</div>}
        {props.subHeader && <div className="sub-header">{props.subHeader}</div>}
        {props.children}
      </div>
    </Modal>
  );
});

export default TempoModal;
